import { render, staticRenderFns } from "./dynamicModuleList.vue?vue&type=template&id=48e6dc8d"
import script from "./dynamicModuleList.vue?vue&type=script&lang=js"
export * from "./dynamicModuleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports